import { useLoaderData } from '@tanstack/react-router';
import { differenceInCalendarDays } from 'date-fns';
import {AccommodationBookingObjectContentModel} from "@shared/integrations/umbraco-taf-delivery-api/models";
import {IAvailableBookingPeriod} from "@shared/integrations/taf-api/v2/models";
import {dateTimeStringToDate} from "@my-pages/features/object-booking/utils/calendarUtils.ts";

interface IAccommodationBookingSummary {
    period: IAvailableBookingPeriod;
}

const AccommodationBookingSummary = ({ period }: IAccommodationBookingSummary) => {
    const loaderData = useLoaderData({ strict: false }) as AccommodationBookingObjectContentModel | undefined | null;

    return (loaderData !== undefined || true) && period ? (
        <div>
            <h5>{loaderData?.name}</h5>
            <div className='d-flex flex-column gap-2 pt-4 mb-4 border-top'>
                {period.startDate && period.endDate ? (
                    <div className='d-flex justify-content-between gap-2 text-muted'>
                        <span>Period</span>
                        <span>
                            {period.startDate ? dateTimeStringToDate(period.startDate) : 'N/A'} - {period.endDate ? dateTimeStringToDate(period.endDate) : 'N/A'}
                        </span>
                    </div>
                ) : null}
                {period.startDate && period.endDate ? (
                    <div className='d-flex justify-content-between gap-2 text-muted'>
                        <span>Längd</span>
                        <span>{differenceInCalendarDays(new Date(period.endDate), new Date(period.startDate))}</span>
                    </div>
                ) : null}
                {period.price ? (
                    <div className='d-flex justify-content-between gap-2 text-muted'>
                        <span>Avgift för period</span>
                        <span>{period.price} kr</span>
                    </div>
                ) : null}
                {period.bookingFee ? (
                    <div className='d-flex justify-content-between gap-2 text-muted'>
                        <span>Bokningsavgift</span>
                        <span>{period.bookingFee} kr</span>
                    </div>
                ) : null}
            </div>
            {period.bookingFee || period.price ? (
                <div className='d-flex flex-column gap-2 border-top pt-4'>
                    <div className='d-flex justify-content-between gap-2 font-size-lg font-weight-medium'>
                        <span>Summa</span>
                        <span>{(period.bookingFee ?? 0) + (period.price ?? 0)} kr</span>
                    </div>
                </div>
            ) : null}
        </div>
    ) : null;
};
export default AccommodationBookingSummary;
